import { ThunkAction } from 'redux-thunk'

import { IProductBrand } from '../DataStore/IProductBrand'
import ProductDataStore from '../DataStore/ProductDataStore'

import {
    ActionTypes,
    GET_PRODUCT_BRANDS_FAILURE,
    GET_PRODUCT_BRANDS_LOADING,
    GET_PRODUCT_BRANDS_SUCCESS,
} from './ActionTypes'

function getProductBrandsSuccess(list: IProductBrand[]): ActionTypes {
    return {
        type: GET_PRODUCT_BRANDS_SUCCESS,
        payload: {
            brands: list,
        },
    }
}

function getProductBrandsFailure(error: any): ActionTypes {
    return {
        type: GET_PRODUCT_BRANDS_FAILURE,
        payload: {
            error,
        },
    }
}

export const getProductBrands = (): ThunkAction<
    any,
    any,
    undefined,
    ActionTypes
> => {
    return (dispatch) => {
        dispatch({ type: GET_PRODUCT_BRANDS_LOADING })

        return ProductDataStore.getProductBrands()
            .then((list) => {
                dispatch(getProductBrandsSuccess(list))
            })
            .catch((error) => {
                dispatch(getProductBrandsFailure(error))
            })
    }
}
